import { Subject } from 'rxjs';
import { UserSettingsService } from 'src/app/shared/services/rest/user-settings.service';
import * as i0 from "@angular/core";
import * as i1 from "./rest/user-settings.service";
var UserSearchTermsService = /** @class */ (function () {
    function UserSearchTermsService(userSettings) {
        this.subjectTopic = 'Reservation';
        this.beforeFormSubmit = new Subject();
        this.formDataRequest = new Subject();
        this.formDataResponse = new Subject();
        this.applyFormData = new Subject();
        this.userSettings = userSettings;
    }
    UserSearchTermsService.prototype.getAllStoredTerms = function () {
        return this.userSettings.get(this.subjectTopic + "?filter.Key=~RoomSearchFavorites/*");
    };
    UserSearchTermsService.prototype.storeSearchTerms = function (termsName, termsData) {
        if (!termsName) {
            throw new Error('parameter `termsName` is a required value');
        }
        // * 'date' field is exempted from user favorites
        delete termsData.date;
        var model = {
            Id: this.subjectTopic,
            Settings: [{ Key: "RoomSearchFavorites/" + termsName, Value: JSON.stringify(termsData) }]
        };
        return this.userSettings.createSettings(this.subjectTopic, model);
    };
    UserSearchTermsService.prototype.discardSearchTerms = function (termsName) {
        if (!termsName) {
            throw new Error('parameter `termsName` is a required value');
        }
        return this.userSettings.createSettings(this.subjectTopic, {
            Id: this.subjectTopic,
            Settings: [{ Key: "RoomSearchFavorites/" + termsName, Value: null }]
        });
    };
    UserSearchTermsService.prototype.storeLastSearchTerms = function (termsData) {
        var relevantFormFieldKeys = ['location', 'building'];
        var storeModel = relevantFormFieldKeys.reduce(function (partialModel, currentKey) {
            var _a;
            return Object.assign(partialModel, (_a = {}, _a[currentKey] = termsData[currentKey], _a));
        }, {});
        var model = {
            Id: this.subjectTopic,
            Settings: [{ Key: "RoomLastSearch", Value: JSON.stringify(storeModel) }]
        };
        return this.userSettings.createSettings(this.subjectTopic, model);
    };
    UserSearchTermsService.prototype.requestLastSearchTerms = function () {
        return this.userSettings.get(this.subjectTopic + "?filter.Key==RoomLastSearch");
    };
    UserSearchTermsService.ngInjectableDef = i0.defineInjectable({ factory: function UserSearchTermsService_Factory() { return new UserSearchTermsService(i0.inject(i1.UserSettingsService)); }, token: UserSearchTermsService, providedIn: "root" });
    return UserSearchTermsService;
}());
export { UserSearchTermsService };
